module.exports = __webpack_public_path__ + "img/arh_1.8ec1a70e.jpg";